export class CreateVpcPeeringInput {
    'awsAccountId';
    'vpcId';
    'cidrs';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cidrs",
            "baseName": "cidrs",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateVpcPeeringInput.attributeTypeMap;
    }
    constructor() {
    }
}
